import {APIRequest} from "../APIRequest.js";
import {GAEvent} from "../../App/GA";
import {getQueryParamValue, getVPCService, isMobile} from "../../App/utils";
import {getPlatform} from "../../utils";

// export const AUTH_API_URL = "https://lq5zc6qzy54epd4uppiekqdigm0mlitk.lambda-url.us-east-1.on.aws/";
export const AUTH_API_URL = getVPCService('auth') || "https://auth.openkbs.com/";
const timeout = 20000;

export const fetchKBJWT = async (kbId, isShared) => {
    const token = localStorage.getItem("clientJWT");
    const action = 'fetchKBJWT';
    const params = {
        token,
        kbId,
        isShared,
        // expTime: 5
    };

    const res = await APIRequest('post', AUTH_API_URL + action, params, {
        headers: {
            'Content-Type': 'application/json',
        }
    });

    return res;
}

export const fetchClientJWT = async ({signup, inputJWT, subscribed, domain}) => {
    const params = {
        inputJWT,
        signup,
        // expTime: 10
    };

    // Add domain if it's a parked domain
    if (domain) {
        params.domain = domain;
    }

    if (signup) {
        const browserInfo = {
            userAgent: navigator?.userAgent,
            platform: navigator?.platform,
            vendor: navigator?.vendor,
            language: navigator?.language,
            languages: navigator?.languages,
            deviceMemory: navigator?.deviceMemory || 'unknown',
            hardwareConcurrency: navigator?.hardwareConcurrency || 'unknown',
        };

        params.href = window.location.href;
        params.referrer = document.referrer;
        params.isMobile = isMobile;
        params.platform = getPlatform() + ' | ' +  JSON.stringify(browserInfo);
        params.subscribed = subscribed;
    }

    if (getQueryParamValue('ip')) params.ip = getQueryParamValue('ip');
    if (getQueryParamValue('whitelabelKbId')) params.whitelabelKbId = getQueryParamValue('whitelabelKbId');
    if (getQueryParamValue('accountId')) params.accountId = getQueryParamValue('accountId');
    if (getQueryParamValue('code')) params.ip = getQueryParamValue('code');
    return await APIRequest('post', AUTH_API_URL, params, {
        headers: {
            'Content-Type': 'application/json',
        }
    });
}

export const uploadImage = async (base64Image) => {
    const token = localStorage.getItem("clientJWT");
    const action = 'uploadImage';

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, {
            token,
            base64Image
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
}

export const verifyPhoneCode = async (code) => {
    const token = localStorage.getItem("clientJWT");
    const action = 'verifyPhoneCode';

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, {
            token,
            code
        }, {timeout});

        // if (response?.data) GAEvent({ category: "engagement", action: "Verify Phone Code Success" });

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const cancelPhoneVerification = async () => {
    const token = localStorage.getItem("clientJWT");
    const action = 'cancelPhoneVerification';

    // GAEvent({ category: "engagement", action: "Cancel Phone Verification"});

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, {
            token
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const sendPhoneVerificationCode = async (phone, country) => {
    const token = localStorage.getItem("clientJWT");
    const action = 'sendPhoneVerificationCode';

    // GAEvent({ category: "engagement", action: "Send Phone Verification Code" });

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, {
            token,
            phone,
            country
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const updateUserBilling = async (billingInfo) => {
    const token = localStorage.getItem("clientJWT");
    const action = 'updateUserBilling';

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, {
            token,
            billingInfo,
        }, { timeout });

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const listInvoices = async () => {
    const token = localStorage.getItem("clientJWT");
    const action = 'listInvoices';

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, { token }, { timeout });
        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const downloadInvoice = async (invoiceId, isReceipt, invoiceLang = 'EN') => {
    const token = localStorage.getItem("clientJWT");
    const action = 'downloadInvoice';

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, { token, invoiceId, isReceipt, invoiceLang }, { responseType: 'arraybuffer' });
        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const getUserBilling = async () => {
    const token = localStorage.getItem("clientJWT");
    const action = 'getUserBilling';

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, { token }, { timeout });
        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};


export const updateUser = async ({phone, name, billingEmail}) => {
    const token = localStorage.getItem("clientJWT");
    const action = 'updateUser';

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, {
            token,
            phone,
            name,
            billingEmail
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const PHONE_VERIFICATION_STATUS = {
    NOT_VERIFIED: 'NOT_VERIFIED',
    IN_PROGRESS: 'IN_PROGRESS',
    VERIFIED: 'VERIFIED',
    CANCELED: 'CANCELED',
}

export const getAccountId = async () => {
    const token = localStorage.getItem('kbJWT');
    const action = 'getAccountId';
    try {
        const response = await APIRequest('post', AUTH_API_URL + action, {
            token
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

let getUserProfilePromise = null; // This will hold the promise for the ongoing request

export const getUserProfile = async () => {
    const token = localStorage.getItem("clientJWT");
    const action = 'getUserProfile';

    // If there's an ongoing request, return the existing promise
    if (getUserProfilePromise) return getUserProfilePromise;

    // Create a new promise for the request
    getUserProfilePromise = (async () => {
        try {
            const response = await APIRequest('post', AUTH_API_URL + action, {
                token
            }, {timeout});

            if (response?.data?.status === 404) {
                return {
                    name: 'User not found',
                    picture: '',
                }
            }

            return response?.data;
        } catch (error) {
            console.error('API request error:', error);
            throw error;
        } finally {
            // Once the request is completed, reset the promise to allow future requests
            getUserProfilePromise = null;
        }
    })();

    return getUserProfilePromise;
};

export const deleteUser = async () => {
    const token = localStorage.getItem("clientJWT");
    const action = 'deleteUser';

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, {
            token
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

// ==================== ORGANIZATION API ====================

export const createOrg = async (orgName) => {
    const token = localStorage.getItem("clientJWT");
    const action = 'createOrg';

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, {
            token,
            orgName
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const joinOrg = async (orgId) => {
    const token = localStorage.getItem("clientJWT");
    const action = 'joinOrg';

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, {
            token,
            orgId
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const removeMember = async (memberUserId) => {
    const token = localStorage.getItem("clientJWT");
    const action = 'removeMember';

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, {
            token,
            memberUserId
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const leaveOrg = async () => {
    const token = localStorage.getItem("clientJWT");
    const action = 'leaveOrg';

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, {
            token
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const listOrgMembers = async () => {
    const token = localStorage.getItem("clientJWT");
    const action = 'listOrgMembers';

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, {
            token
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const getOrgInfo = async () => {
    const token = localStorage.getItem("clientJWT");
    const action = 'getOrgInfo';

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, {
            token
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const updateOrg = async ({ orgName, orgColor }) => {
    const token = localStorage.getItem("clientJWT");
    const action = 'updateOrg';

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, {
            token,
            orgName,
            orgColor
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const deleteOrg = async () => {
    const token = localStorage.getItem("clientJWT");
    const action = 'deleteOrg';

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, {
            token
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

// ==================== IMPERSONATION DELEGATION API ====================

export const addImpersonator = async (email) => {
    const token = localStorage.getItem("clientJWT");
    const action = 'addImpersonator';

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, {
            token,
            email
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const removeImpersonator = async (email) => {
    const token = localStorage.getItem("clientJWT");
    const action = 'removeImpersonator';

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, {
            token,
            email
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const listImpersonators = async () => {
    const token = localStorage.getItem("clientJWT");
    const action = 'listImpersonators';

    try {
        const response = await APIRequest('post', AUTH_API_URL + action, {
            token
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

